// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__oR9qm","homeTitle":"Home_homeTitle__2zykz","dividerHolder":"Home_dividerHolder__10Muw","divider":"Home_divider__3PPgV"};